import { render, staticRenderFns } from "./UnderClip.vue?vue&type=template&id=2383b975&scoped=true"
import script from "./UnderClip.vue?vue&type=script&lang=js"
export * from "./UnderClip.vue?vue&type=script&lang=js"
import style0 from "./UnderClip.vue?vue&type=style&index=0&id=2383b975&prod&lang=scss"
import style1 from "./UnderClip.vue?vue&type=style&index=1&id=2383b975&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2383b975",
  null
  
)

export default component.exports